// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"2f1b3bfd","181":"3b091b2f","281":"bce9decf","398":"52209f9b","971":"19c20a35"}[chunkId] + ".chunk.css";
};